import { createSlice } from '@reduxjs/toolkit';

export const comonSlice = createSlice({
  name: 'language',
  initialState: {
    value: 'en', // Default language
  },
  reducers: {
    setLanguage: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setLanguage } = comonSlice.actions;

export default comonSlice.reducer;